import { render, staticRenderFns } from "./GrowthPercentText.vue?vue&type=template&id=1ad1d144&scoped=true&"
import script from "./GrowthPercentText.vue?vue&type=script&lang=js&"
export * from "./GrowthPercentText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad1d144",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
